"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionHeaderWrapper = exports.ProductSettingsSectionWrapper = exports.InputFieldContainer = exports.InputFieldsSection = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.InputFieldsSection = styled_components_1.default.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 16px;
  grid-column-gap: 16px;
  margin: 8px 16px 16px 16px;
  @media screen and (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
  @media screen and (min-width: 1400px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (min-width: 2556px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;
exports.InputFieldContainer = styled_components_1.default.div `
  margin: 16px;
`;
exports.ProductSettingsSectionWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  border: 1px solid ${colors_1.LIGHT_GREY};
  width: 100%;
  margin-bottom: 32px;
`;
exports.SectionHeaderWrapper = styled_components_1.default.div `
  margin: 8px 16px 0px 16px;
`;
//# sourceMappingURL=ProductSettingsSection.styles.js.map